import { AxiosResponse } from "axios";
import api from "../../../../helper/axios";
import { Gadget } from "../../../../models/GadgetModel";
import { GadgetPlaform } from "./GadgetPlaform";
import { GadgetSortColumns } from "./GadgetModel";

export interface GadgetPaginatedResponse {
  total_pages: number;
  total_items: number;
  data: Gadget[];
}

export enum Method {
  GET = "GET",
  HEAD = "HEAD",
  POST = "POST",
  PUT = "PUT",
  DELETE = "DELETE"
}

export interface GadgetUrlRequest {
  version: string;
  method: Method;
  platform: GadgetPlaform
}

export interface PreSignedUrlResponse {
  url: string
}

class GadgetRepository {
  getAllPublished = async (
    pagenumber: number,
    pageSize: number,
    sortModel: GadgetSortColumns,
    platform: GadgetPlaform,
    provider: string,
    gadgetName?: string
  ): Promise<GadgetPaginatedResponse> => {
      const headers = {
          "page_no": `${pagenumber}`,
          "size": `${pageSize}`,
          "sort_by":`${sortModel.field}`,
          "sort_order": `${sortModel.order}`,
      }
      let path = `/public/gadgets?platform=${platform.toUpperCase()}&provider=${provider}&name=${gadgetName}`;
      return await api.get<GadgetPaginatedResponse>(`${path}`, { headers: headers })
        .then(response => {
            return response.data
        })
        .catch((error) => {
            throw new Error(error)
        })
    }

    getByGadgetId = async (gadgetId:number, provider: string): Promise<Gadget> => {
      return await api.get<Gadget>(`/public/gadgets/${gadgetId}?provider=${provider}`)
        .then(response => {
            return response.data
        })
        .catch((error) => {
            throw new Error(error)
        })
    }

    getPreSignedUrl = async (gadgetId:number, gadgetUrlRequest: GadgetUrlRequest): Promise<PreSignedUrlResponse> => {
      const response = await api
        .post<
          GadgetUrlRequest,
          AxiosResponse<PreSignedUrlResponse>
          >(`/gadgets/${gadgetId}/pre-signed-url`, gadgetUrlRequest)
        .then(response => {
            return response.data;
        })
        .catch((error) => {
            throw new Error(error)
        });
        return response;
    }
}

export class GadgetDaoFactory {
  public static getGadgetRepository() {
    return new GadgetRepository();
  }
}
